import { Component } from '@angular/core';
import { MediaPanelInfo } from '../../../../../models/datamodel/mediasource.model';
import { BaseMediaSourcePanel } from '../basemediasource.panel';

@Component({
    selector: 'minio-panel',
    templateUrl: './minio.panel.html',
    styleUrls: ['./minio.panel.css']
})
export class MinioPanel extends BaseMediaSourcePanel {
    static GetInfo(): MediaPanelInfo {
        return { 
            ControlType: MinioPanel,
            MediaType: '4eb395d4-5b74-47de-9951-ee308b1724d8'
        };
    }
}
